module.exports = __webpack_public_path__ + "img/vip-level2.fc697629.png";